import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import ApiService from "../../ApiService";
import AddAcquirerAccountForm from "./AddAcquirerAccountForm";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import Divider from "@material-ui/core/Divider";
import MaterialTable from "../../components/MaterialTable";
import Select from "@material-ui/core/Select";
import SearchIcon from "@material-ui/icons/Search";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import { Alert, Autocomplete } from "@mui/material";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { forwardRef } from "react";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import AddIcon from "@material-ui/icons/Add";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import EditIcon from "@material-ui/icons/Edit";
import GridItem from "../../components/Custom/Grid/GridItem";
import GridContainer from "../../components/Custom/Grid/GridContainer";
import { Button as MTButton } from "@mui/material";
import CustomTooltip from "../../components/Custom/Tooltip/Tooltip";
import TextField from "@material-ui/core/TextField";
import { Button, Grid, IconButton, TablePagination } from "@material-ui/core";
import { MTableToolbar } from "material-table";

const useStyles = (theme) => ({
  button: {
    margin: theme.spacing(1),
  },

  detailhead: {
    fontSize: 12,
  },
  searchbar: {
    margin: theme.spacing(2),
  },
  formControl: {
    marginLeft: 20,
    minWidth: 120,
    maxWidth: 300,
  },
  formControlOne: {
    marginLeft: 20,
    minWidth: 200,
    maxWidth: 300,
  },
  buttonProgress: {
    color: theme.palette.secondary.main,
    position: "absolute",
    marginTop: 8,
    marginLeft: -65,
  },
});

class AcquirerAccountComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      failed: false,
      success: false,
      responsemessage: null,
      acquirers: [],
      selectedAcquirer: null,
      selectedCardType: [],
      accounts: [],
      account: null,
      addAcquirerPanelVisible: false,
      addAccountPanelVisible: false,
      cardTypes: [],
      paymentModes: [],
      mid: null,
      userName: null,
      billingDesc: null,
      pool: null,
      numberRowPerPage: 50,
      totalRow: 0,
      pageNumber: 0,
      selectedRows: [],
    };

    this.handleChange = this.handleChange.bind(this);
    this.searchAcquirers = this.searchAcquirers.bind(this);

    this.reloadData = this.reloadData.bind(this);
    this.showAccountPanel = this.showAccountPanel.bind(this);
    this.hideAccountPanel = this.hideAccountPanel.bind(this);
    this.fetchAllAcquirers = this.fetchAllAcquirers.bind(this);

    this.fetchAccounts = this.fetchAccounts.bind(this);
    this.fetchAccountsById = this.fetchAccountsById.bind(this);

    this.postAdd = this.postAdd.bind(this);
    this.reloadData();

    this.handleMidChange = this.handleMidChange.bind(this);
    this.handleUserNameChange = this.handleUserNameChange.bind(this);
    this.handleBillingDescChange = this.handleBillingDescChange.bind(this);
    this.handlePoolChange = this.handlePoolChange.bind(this);
    this.handleCardChange = this.handleCardChange.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleAcquirerChange = (event, newValue) => {
    let acq = newValue ? newValue : null;
    this.setState({
      selectedAcquirer: acq,
    });
  };
  handleMidChange(event) {
    this.setState({ mid: event.target.value });
  }
  handleUserNameChange(event) {
    this.setState({ userName: event.target.value });
  }
  handleBillingDescChange(event) {
    this.setState({ billingDesc: event.target.value });
  }
  handlePoolChange(event) {
    this.setState({ pool: event.target.value });
  }
  handleCardChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleChangePage(e, pageNo) {
    this.setState({ pageNumber: pageNo });
    this.fetchAccounts(pageNo);
  }

  reloadData() {
    this.fetchAllAcquirers();
  }

  componentDidMount() {
    ApiService.fetchAllCardType().then((res) => {
      this.setState({ cardTypes: res.data });
    });

    ApiService.fetchAllPaymentMode().then((res) => {
      this.setState({ paymentModes: res.data });
    });
  }

  fetchAllAcquirers() {
    ApiService.fetchAllAcquirers()
      .then((res) => {
        this.setState({ acquirers: res.data });
      })
      .catch((e) => {});
  }

  fetchAccountsById(
    acquirer,
    id,
    userName,
    mid,
    billingDesc,
    pool,
    rowPerPage,
    pageNo
  ) {
    if (acquirer || acquirer !== null) {
      ApiService.fetchAcquirerAccountsByAcquirer(
        acquirer,
        id,
        userName,
        mid,
        billingDesc,
        pool,
        rowPerPage,
        pageNo
      )
        .then((res) => {
          this.setState({ accounts: res.data, totalRow: res.data.totalRow });
        })
        .catch((e) => {});
    }
  }

  fetchAccounts(pageNo) {
    try {
      this.fetchAccountsById(
        this.state.selectedAcquirer.acquirerId,
        this.state.selectedCardType.id,
        this.state.userName,
        this.state.mid,
        this.state.billingDesc,
        this.state.pool,
        this.state.numberRowPerPage,
        pageNo
      );
    } catch (error) {}
  }

  showAccountPanel() {
    this.setState({ addAccountPanelVisible: true });
  }
  hideAccountPanel() {
    this.setState({ addAccountPanelVisible: false });
    this.setState({ account: null });
  }
  amendAccount(data) {
    data.map((d) => {
      this.setState({ account: d });
    });
    this.showAccountPanel();
  }

  searchAcquirers() {
    this.setState({ pageNumber: 0 });
    if (this.state.selectedAcquirer === null) {
      this.setState({
        responsemessage: "Please select Acquirer",
        failed: true,
      });

      return;
    } else {
      this.setState({
        failed: false,
      });
      this.fetchAccounts(0);
    }
  }
  postAdd() {
    //this.hideAccountPanel();
    this.fetchAccounts();
  }
  tableIcons = {
    Add: forwardRef((props, ref) => <AddIcon {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  };

  render() {
    const { classes } = this.props;
    const {
      selectedAcquirer,
      accounts,
      account,
      cardTypes,
      paymentModes,
      selectedRows,
      numberRowPerPage,
      pageNumber,
      acquirers,
    } = this.state;

    const isMultipleSelection = selectedRows.length > 1;

    return (
      <React.Fragment>
        <Paper style={{ margin: "1em", padding: "1em" }}>
          <Typography component="h2" variant="h6" color="primary" gutterBottom>
            Acquirer Account management
          </Typography>
          <Divider light className={classes.searchbar} />
          {this.state.failed && (
            <Alert severity="error" elevation="0">
              {" "}
              {this.state.responsemessage}
            </Alert>
          )}
          {this.state.success && (
            <Alert severity="success" elevation="0">
              {this.state.responsemessage}
            </Alert>
          )}
          <GridContainer>
            {/* <GridItem xs={8} sm={8} md={4} lg={3}>
              <FormControl className={classes.formControl}>
                <InputLabel id="acqSelectLabel">Acquirers</InputLabel>
                <Select
                  value={selectedAcquirer}
                  MenuProps={this.MenuProps}
                  onChange={this.handleChange}
                  name="selectedAcquirer"
                  labelId="acqSelectLabel"
                  id="acqSelect"
                >
                  <MenuItem key="" value="">
                    &nbsp;{" "}
                  </MenuItem>
                  {this.state.acquirers &&
                    this.state.acquirers.map((a) => (
                      <MenuItem key={a.acquirerId} value={a} dense>
                        {a.name + "-" + a.number}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </GridItem> */}

            <Grid item xs={8} sm={8} md={4} lg={3}>
              <FormControl className={classes.formControlOne}>
                <Autocomplete
                  value={selectedAcquirer}
                  onChange={this.handleAcquirerChange}
                  options={acquirers}
                  getOptionLabel={(option) =>
                    option ? option.name + "-" + option.number : ""
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      labelId="acqSelectLabel"
                      id="acqSelect"
                      label="Acquirers"
                      variant="outlined"
                    />
                  )}
                />
              </FormControl>
            </Grid>
            <GridItem xs={8} sm={8} md={4} lg={3}>
              <FormControl className={classes.formControl}>
                <InputLabel id="acqCardTypeLabel">Card Type</InputLabel>
                <Select
                  value={this.state.selectedCardType}
                  onChange={this.handleCardChange}
                  name="selectedCardType"
                  labelId="cardTypeLabel"
                  id="cardSelect"
                >
                  <MenuItem key="" value="">
                    &nbsp;{" "}
                  </MenuItem>
                  {this.state.cardTypes &&
                    this.state.cardTypes.map((a) => (
                      <MenuItem key={a.id} value={a} dense>
                        {a.type}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </GridItem>
            <GridItem xs={12} sm={6} md={4} lg={2} style={{ marginTop: "4px" }}>
              <TextField
                id="userName"
                label="Username"
                onChange={this.handleUserNameChange}
                className={classes.formControl}
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={4} lg={2} style={{ marginTop: "4px" }}>
              <TextField
                id="mid"
                label="MID"
                onChange={this.handleMidChange}
                className={classes.formControl}
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={4} lg={2} style={{ marginTop: "4px" }}>
              <TextField
                id="billingDesc"
                label="Billing Desc"
                onChange={this.handleBillingDescChange}
                className={classes.formControl}
              />
            </GridItem>

            <GridItem xs={12} sm={6} md={4} lg={2} style={{ marginTop: "4px" }}>
              <TextField
                id="pool"
                label="Pool"
                onChange={this.handlePoolChange}
                className={classes.formControl}
              />
            </GridItem>

            <GridItem xs={12} sm={6} md={4} lg={2} style={{ marginTop: "8px" }}>
              <Button
                variant="contained"
                color="primary"
                size="small"
                className={classes.button}
                startIcon={<SearchIcon />}
                onClick={this.searchAcquirers}
              >
                Search
              </Button>
            </GridItem>
            {selectedAcquirer && (
              <GridItem xs={12} sm={12} md={12} lg={12}>
                <Table size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Acquirer id </TableCell>
                      <TableCell>Code</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Number</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow key="2">
                      <TableCell>{selectedAcquirer.acquirerId} </TableCell>
                      <TableCell>{selectedAcquirer.code}</TableCell>
                      <TableCell>{selectedAcquirer.name}</TableCell>
                      <TableCell>{selectedAcquirer.number}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </GridItem>
            )}
          </GridContainer>

          <MaterialTable
            style={{ margin: "1em 0 0 0" }}
            title="Acquirer accounts"
            icons={this.tableIcons}
            columns={[
              {
                field: "acquirerAccountId",
                numeric: false,
                title: "Id",
                render: (rowData) => (
                  <>
                    <CustomTooltip
                      title={rowData.acquirerAccountId}
                      copy={true}
                    >
                      <InfoOutlinedIcon />
                    </CustomTooltip>
                  </>
                ),
              },
              { field: "mid", numeric: false, title: "MID" },
              { field: "accountNumber", numeric: false, title: "Account no" },
              { field: "paymentMode.mode", numeric: false, title: "Pay mode" },
              { field: "cardType.type", numeric: false, title: "Card type" },
              {
                field: "settlementCurrency",
                numeric: false,
                title: "Currency",
              },
              { field: "userName", numeric: false, title: "Username" },
              {
                field: "billingDescriptor",
                numeric: false,
                title: "Billing Desc",
              },
              { field: "accountPoolId", numeric: false, title: "Pool" },
              { field: "dailyNotionalLimit", numeric: true, title: "Limit" },
            ]}
            data={accounts.responseObject}
            actions={[
              {
                icon: (props) => (
                  <MTButton
                    variant="contained"
                    disabled={
                      selectedAcquirer === null || selectedAcquirer === ""
                    }
                    color="primary"
                    size="small"
                    startIcon={<AddIcon />}
                  >
                    Add Account
                  </MTButton>
                ),
                tooltip: "Add Account",
                isFreeAction: true,
                onClick: (event) => this.showAccountPanel(),
              },

              {
                //tooltip: "Amend selected Account",
                icon: (props) =>
                  isMultipleSelection ? (
                    <IconButton disabled>
                      <EditIcon {...props} />
                    </IconButton>
                  ) : (
                    <EditIcon {...props} />
                  ),
                onClick: (evt, data) =>
                  isMultipleSelection ? null : this.amendAccount(data),
              },
            ]}
            options={{
              search: false,
              exportButton: false,
              paginationType: "normal",
              pageSize: numberRowPerPage,
              pageSizeOption: [],
              padding: "dense",
              showEmptyDataSourceMessage: true,
              selection: true,
              emptyRowsWhenPaging: false,
              selectionProps: false,
            }}
            components={{
              Pagination: (props) => (
                <TablePagination
                  {...props}
                  rowsPerPageOptions={[]}
                  rowsPerPage={numberRowPerPage}
                  count={this.state.totalRow}
                  page={pageNumber}
                  onChangePage={(e, page) => this.handleChangePage(e, page)}
                />
              ),

              Toolbar: (props) => (
                <div>
                  {isMultipleSelection && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "8px",
                        backgroundColor: "white",
                      }}
                    >
                      <span style={{ marginLeft: "8px", color: "red" }}>
                        Multiple rows selected. Please select only one row to
                        edit.
                      </span>
                    </div>
                  )}
                  <MTableToolbar {...props} />
                </div>
              ),
            }}
            onSelectionChange={(rows) => {
              this.setState({ selectedRows: rows });
            }}
          />
        </Paper>
        {selectedAcquirer && (
          <Dialog
            open={this.state.addAccountPanelVisible}
            onClose={this.hideAccountPanel}
          >
            <DialogTitle
              id="customized-dialog-title"
              onClose={this.hideAccountPanel}
            >
              {account == null ? "Add Account" : "Amend Account"}
            </DialogTitle>
            <DialogContent>
              <AddAcquirerAccountForm
                account={account}
                acquirerId={selectedAcquirer.acquirerId}
                hide={this.postAdd}
                cardTypes={cardTypes}
                paymentModes={paymentModes}
              />
            </DialogContent>
          </Dialog>
        )}
      </React.Fragment>
    );
  }
}
export default withStyles(useStyles)(AcquirerAccountComponent);
